import { combineReducers } from 'redux'
import { sessionReducer } from 'redux-react-session'

import modal from './modal'
import campaigns from './campaigns'
import segments from './segments'
import events from './events'

export default combineReducers({
  session: sessionReducer,
  modal,
  campaigns,
  segments,
  events,
})


// WEBPACK FOOTER //
// ./src/actions/index.js